module.exports = __webpack_public_path__ + "static/media/banner_servico_educativo.dc0b5166.webp";